/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useMemo, useState } from "react";
import useStyles from "./style";
import {
  Avatar,
  AvatarBadge,
  Box,
  Button,
  Flex,
  Grid,
  Icon,
  Image,
  Input,
  Progress,
  Text,
} from "@chakra-ui/react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Header from "components/header";
import Footer from "components/footerUser";
import {
  FormControlLabel,
  LinearProgress,
  Radio,
  RadioGroup,
} from "@mui/material";
import {
  ChevronDownIcon,
  ChevronUpIcon,
  CloseIcon,
  Search2Icon,
} from "@chakra-ui/icons";
import PersonIcon from "@mui/icons-material/Person";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import Add from "../../assets/img/add.png";
import moment from "moment";

import axios from "axios";
import { useLocation } from "react-router-dom";
import { MdLock } from "react-icons/md";
import PricingPersona from "views/pricingPersona";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const Persona = (props) => {
  const styles = useStyles();
  const [user, setUser] = useState();
  const [nameUser, setNameUser] = useState("");
  const [nameColleague, setNameColleague] = useState("");
  const [localUser, setLocalUser] = useState();
  const [showDialog, setShowDialog] = useState(false);
  const [personaMode, setPersonaMode] = useState(0);
  const [searchData, setSearchData] = useState([]);
  const [activeCard, setActiveCard] = useState(0);
  const [stats, setStats] = useState(0);
  const [open, setOpen] = useState("");
  const [cards, setCards] = useState([]);
  const [showPilihan, setShowPilihan] = useState(false);
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [isShowPricing, setIsShowPricing] = useState(false);
  const [service, setService] = useState();

  useEffect(() => {
    const token = localStorage.getItem("token");
    let locUser = localStorage.getItem("user");
    setLocalUser(JSON.parse(locUser));
    if (props?.match?.params?.id && props?.match?.params?.type) {
      axios
        .get(
          `https://api.personatalenta.id/user/${props.match.params.type}/${props.match.params.id}`,
          {
            headers: {
              Authorization: `Bearer ${token ? token : ""}`,
              "Content-Type": "x-www-from-urlencode",
              "Access-Control-Allow-Origin": "http://localhost:3000",
              "Access-Control-Allow-Credentials": "true",
              "Access-Control-Allow-Headers":
                "Origin, X-Requested-With, Content-Type, Accept",
            },
          },
        )
        .then((res) => {
          setUser(res.data.user ?? res.data.colleagues);
        })
        .catch((err) => {
          if (
            err.response?.data?.message === "Unauthorized" ||
            err.response?.data === "Unauthorized"
          ) {
            // navigate('/');
          }
        });
    } else {
      if (locUser) {
        setUser(JSON.parse(locUser));
      } else {
        setUser("guess");
        // window.location.assign('/home')
      }
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    let type = "profile";
    if (activeCard === 0) {
      type = "profile";
    } else if (activeCard === 1) {
      type = "this_year";
    } else if (activeCard === 2) {
      type = "today";
    }

    if (token && user) {
      axios
        .get(
          `https://api.personatalenta.id/persona/${type}?user_id=${
            user?.id
          }&buyer_id=${localUser?.id}${
            activeCard === 2 ? `&date=${moment().format("YYYY-MM-DD")}` : ""
          }&is_has_user_id=${
            personaMode === 1 || personaMode === 0 ? "true" : "false"
          }`,
          {
            headers: {
              Authorization: `Bearer ${token ? token : ""}`,
              "Content-Type": "x-www-from-urlencode",
              "Access-Control-Allow-Origin": "http://localhost:3000",
              "Access-Control-Allow-Credentials": "true",
              "Access-Control-Allow-Headers":
                "Origin, X-Requested-With, Content-Type, Accept",
            },
          },
        )
        .then((res) => {
          setCards(res?.data?.cards);
          setIsUnlocked(res?.data?.is_unlocked);
        })
        .catch((err) => {
          if (
            err.response.data.message === "Unauthorized" ||
            err.response.data === "Unauthorized"
          ) {
            // navigate('/');
          }
        });
      if (activeCard === 2) {
        //matching/daily-vibe
        let url = "https://api.personatalenta.id/matching/daily-vibe";
        if (
          (personaMode === 0 && user.id !== localUser.id) ||
          personaMode === 1
        ) {
          url = `https://api.personatalenta.id/matching/daily-vibe/${
            user?.id
          }?type=${personaMode === 0 ? "2" : "1"}`;
        }
        axios
          .get(url, {
            headers: {
              Authorization: `Bearer ${token ? token : ""}`,
              "Content-Type": "x-www-from-urlencode",
              "Access-Control-Allow-Origin": "http://localhost:3000",
              "Access-Control-Allow-Credentials": "true",
              "Access-Control-Allow-Headers":
                "Origin, X-Requested-With, Content-Type, Accept",
            },
          })
          .then((res) => {
            setStats(res.data.percentage);
          })
          .catch((err) => {
            if (
              err.response.data.message === "Unauthorized" ||
              err.response.data === "Unauthorized"
            ) {
              // navigate('/');
            }
          });
      }
    }
  }, [user, activeCard, personaMode]);

  useEffect(() => {
    console.log(user);
    if (user !== "guess") {
      const token = localStorage.getItem("token");
      if (personaMode === 0) {
        const baseUrl = "https://api.personatalenta.id/user/service/table-list";
        axios
          .get(baseUrl, {
            headers: {
              Authorization: `Bearer ${token ? token : ""}`,
              "Content-Type": "x-www-from-urlencode",
            },
          })
          .then((res) => {
            console.log(res);
            if (res?.data?.products) {
              setService(res.data.products);
            }
          })
          .catch((err) => {
            if (
              err.response.data.message === "Unauthorized" ||
              err.response.data === "Unauthorized"
            ) {
              // navigate('/');
            }
          });
      } else if (personaMode === 1) {
        const baseUrl = `https://api.personatalenta.id/user/service/table-list-friend/${user?.id}?is_has_user_id=true`;
        axios
          .get(baseUrl, {
            headers: {
              Authorization: `Bearer ${token ? token : ""}`,
              "Content-Type": "x-www-from-urlencode",
            },
          })
          .then((res) => {
            if (res?.data?.products) {
              setService(res.data.products);
            }
          })
          .catch((err) => {
            if (
              err.response.data.message === "Unauthorized" ||
              err.response.data === "Unauthorized"
            ) {
              // navigate('/');
            }
          });
      } else if (personaMode === 2) {
        const baseUrl = `https://api.personatalenta.id/user/service/table-list-friend/${user?.id}?is_has_user_id=false`;
        axios
          .get(baseUrl, {
            headers: {
              Authorization: `Bearer ${token ? token : ""}`,
              "Content-Type": "x-www-from-urlencode",
            },
          })
          .then((res) => {
            if (res?.data?.products) {
              setService(res.data.products);
            }
          })
          .catch((err) => {
            if (
              err.response.data.message === "Unauthorized" ||
              err.response.data === "Unauthorized"
            ) {
              // navigate('/');
            }
          });
      }
    }
  }, [user, personaMode]);

  const onChangeSearch = (text) => {
    if (personaMode === 1) {
      setNameUser(text.target.value);
    } else {
      setNameColleague(text.target.value);
    }
    const token = localStorage.getItem("token");

    if (token) {
      if (text.target.value.length > 2) {
        if (personaMode === 2) {
          axios
            .get(
              `https://api.personatalenta.id/user/colleague?search=${text.target.value}`,
              {
                headers: {
                  Authorization: `Bearer ${token ? token : ""}`,
                  "Content-Type": "x-www-from-urlencode",
                  "Access-Control-Allow-Origin": "http://localhost:3000",
                  "Access-Control-Allow-Credentials": "true",
                  "Access-Control-Allow-Headers":
                    "Origin, X-Requested-With, Content-Type, Accept",
                },
              },
            )
            .then((res) => {
              setSearchData(res?.data?.colleagues);
              // setCards(res?.data?.cards)
            })
            .catch((err) => {
              if (
                err.response?.data?.message === "Unauthorized" ||
                err.response?.data === "Unauthorized"
              ) {
                // navigate('/');
              }
            });
        } else {
          axios
            .get(
              `https://api.personatalenta.id/user/friendship/find-friend?search=${text.target.value}`,
              {
                headers: {
                  Authorization: `Bearer ${token ? token : ""}`,
                  "Content-Type": "x-www-from-urlencode",
                  "Access-Control-Allow-Origin": "http://localhost:3000",
                  "Access-Control-Allow-Credentials": "true",
                  "Access-Control-Allow-Headers":
                    "Origin, X-Requested-With, Content-Type, Accept",
                },
              },
            )
            .then((res) => {
              setSearchData(res?.data?.users);
              // setCards(res?.data?.cards)
            })
            .catch((err) => {
              if (
                err.response?.data?.message === "Unauthorized" ||
                err.response?.data === "Unauthorized"
              ) {
                // navigate('/');
              }
            });
        }
      } else {
        setSearchData([]);
      }
    }
  };

  const handleClose = () => {
    setShowDialog(false);
  };

  const onClickCard = (index) => {
    setActiveCard(index);
  };

  const onClickOpen = (text) => {
    if (isUnlocked) {
      if (text === open) {
        setOpen("");
      } else {
        setOpen(text);
      }
    } else {
      setIsShowPricing(true);
      // if (
      //   (personaMode === 0 && user.id !== localUser.id) ||
      //   personaMode === 1
      // ) {
      //   if (activeCard === 0 || activeCard === 1) {
      //     window.location.assign(
      //       `/dashboard/friend-list/${
      //         personaMode === 1 ? "friend" : "colleague"
      //       }/${user?.id}/checkout/14`
      //     );
      //   } else {
      //     window.location.assign(
      //       `/dashboard/friend-list/${
      //         personaMode === 1 ? "friend" : "colleague"
      //       }/${user?.id}/checkout/14`
      //     );
      //   }
      // } else {
      //   if (activeCard === 0 || activeCard === 1) {
      //     window.location.assign(`/pricing#persona`);
      //   } else {
      //     window.location.assign(`/pricing#persona`);
      //   }
      // }
    }
  };

  const onSelectUser = (data) => {
    setUser(data);
    setSearchData([]);
    if (personaMode === 1) {
      setNameUser(data.name);
    } else {
      setNameColleague(data.name);
    }
    setShowPilihan(false);
  };

  const onChangeMode = (mode) => {
    setPersonaMode(mode);
    setSearchData([]);
    setNameUser("");
    setNameColleague("");
  };

  const handleClosePricing = () => {
    setIsShowPricing(false);
  };

  return (
    <div className={styles.app}>
      <Header active="persona" />
      <div className={styles.heroContainer}>
        <Flex maxWidth={1080} width="100%">
          <Flex direction={{ base: "column", md: "row" }} gap={10}>
            <Flex flex={5} gap={3} direction="column">
              <Flex direction="column">
                <Flex
                  bgColor="#1a7b28ff"
                  borderTopRadius={10}
                  width="100%"
                  py={2}
                  px={3}
                >
                  <Text
                    color="white"
                    fontWeight="bold"
                    textTransform="uppercase"
                  >
                    Persona
                  </Text>
                </Flex>
                <Flex
                  direction="column"
                  paddingTop={5}
                  paddingBottom={5}
                  borderLeftWidth={1}
                  borderRightWidth={1}
                >
                  {user === "guess" ? (
                    <>
                      <Flex
                        flexDirection="row"
                        justifyContent="space-between"
                        alignItems="center"
                        mb={2}
                      >
                        <Text fontWeight="bold">Cara Menggunakan PERSONA</Text>
                        <Button
                          size="sm"
                          bgColor="#0045B0"
                          color="white"
                          fontSize="sm"
                          px={3}
                          py={1}
                          borderRadius="5px"
                          onClick={() => {
                            localStorage.setItem("redirect_url", "/persona");
                            window.location.assign("/login");
                          }}
                          _hover={{ bg: "#00348a" }}
                        >
                          Daftar Gratis
                        </Button>
                      </Flex>
                      <ol style={{ paddingLeft: "15px", fontSize: "14px" }}>
                        <li style={{ paddingLeft: "10px" }}>
                          <Flex
                            direction="row"
                            alignItems="center"
                            flexWrap="wrap"
                            gap={2}
                          >
                            <Text>
                              Silakan untuk Daftar / Login terlebih dahulu.
                            </Text>
                          </Flex>
                        </li>
                        <li style={{ paddingLeft: "10px" }}>
                          <Text>
                            Pastikan data kelahiranmu benar :
                            Tahun/Bulan/Hari/Jam, Jenis Kelamin. Data ini
                            mempengaruhi akurasi hasil profilingmu, untuk edit
                            data bisa di cek di{" "}
                            <Text
                              as="span"
                              cursor="pointer"
                              textDecoration="underline"
                              onClick={() => {
                                localStorage.setItem(
                                  "redirect_url",
                                  "/persona",
                                );
                                window.location.assign("/login");
                              }}
                            >
                              Dashboard
                            </Text>{" "}
                            {"->"} Edit Profile.
                          </Text>
                        </li>
                        <li style={{ paddingLeft: "10px" }}>
                          <Text>
                            Setelah kamu Login, tampilan yang muncul pertama
                            adalah My Persona, yaitu persona diri kamu.
                          </Text>
                        </li>
                        <li style={{ paddingLeft: "10px" }}>
                          <Text>
                            Untuk mengganti Persona lainnya, pilihlah salah satu
                            Persona yang ingin kamu tampilkan :
                          </Text>
                          <ol type="a" style={{ paddingLeft: "20px" }}>
                            <li>
                              <Text>Persona Diri Sendiri ( My Persona),</Text>
                            </li>
                            <li>
                              <Text>
                                Friend Persona dari pencarian pengguna aplikasi.
                              </Text>
                            </li>
                            <li>
                              <Text>
                                Colleague melalui pencarian yang sudah kamu
                                buat, dan atau kamu tambahkan melalui form input
                                manual dengan klik icon orang.
                              </Text>
                            </li>
                          </ol>
                        </li>
                      </ol>
                      <Text fontSize="14px" mt={2}>
                        Selamat mencoba!
                      </Text>
                    </>
                  ) : (
                    <>
                      <Text fontWeight="bold">Cara Menggunakan PERSONA</Text>
                      <ol style={{ paddingLeft: "15px", fontSize: "14px" }}>
                        <li style={{ paddingLeft: "10px" }}>
                          <Text>
                            Pastikan data kelahiranmu benar :
                            Tahun/Bulan/Hari/Jam, Jenis Kelamin. Data ini
                            mempengaruhi akurasi hasil profilingmu, untuk edit
                            data bisa di cek di{" "}
                            <Text
                              as="span"
                              cursor="pointer"
                              textDecoration="underline"
                              onClick={() => {
                                localStorage.setItem(
                                  "redirect_url",
                                  "/persona",
                                );
                                window.location.assign("/dashboard/profile");
                              }}
                            >
                              Dashboard
                            </Text>{" "}
                            {"->"} Edit Profile.
                          </Text>
                        </li>
                        <li style={{ paddingLeft: "10px" }}>
                          <Text>
                            Setelah kamu Login, tampilan yang muncul adalah My
                            Persona, yaitu persona diri kamu.
                          </Text>
                        </li>
                        <li style={{ paddingLeft: "10px" }}>
                          <Text>
                            Untuk mengganti Persona lainnya, pilihlah salah satu
                            Persona yang ingin kamu tampilkan :
                          </Text>
                          <ol type="a" style={{ paddingLeft: "20px" }}>
                            <li>
                              <Text>Persona Diri Sendiri ( My Persona),</Text>
                            </li>
                            <li>
                              <Text>
                                Friend Persona dari pencarian pengguna aplikasi.
                              </Text>
                            </li>
                            <li>
                              <Text>
                                Colleague melalui pencarian yang sudah kamu
                                buat, dan atau kamu tambahkan melalui form input
                                manual dengan klik icon orang.
                              </Text>
                            </li>
                          </ol>
                        </li>
                      </ol>
                      <Text fontSize="14px" mt={2}>
                        Selamat mencoba!
                      </Text>
                    </>
                  )}
                </Flex>
                <Flex
                  flexDirection="column"
                  w="100%"
                  gap={1}
                  display={{ base: "none", md: "flex" }}
                >
                  <Flex
                    flexDirection="column"
                    px={3}
                    py={2}
                    bgColor="#F7E6D8"
                    w="100%"
                    gap={2}
                  >
                    <Text>
                      Mengenali persona diri sendiri maupun orang lain punya
                      banyak manfaat, baik dalam kehidupan pribadi maupun
                      profesional. Berikut beberapa manfaat utamanya:
                    </Text>
                    <ol style={{ paddingLeft: "20px" }}>
                      <li>
                        <Text>
                          Meningkatkan Pemahaman Diri: Kamu jadi lebih sadar
                          akan kekuatan, kelemahan, pola pikir, dan reaksi
                          emosionalmu. Bisa membantu menentukan tujuan hidup
                          yang lebih selaras dengan kepribadianmu.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          Pengembangan Diri : Dengan mengenali siapa dirimu
                          sebenarnya, kamu bisa lebih fokus dalam mengembangkan
                          potensi dan memperbaiki area yang perlu ditingkatkan.
                          Lebih mudah menentukan gaya belajar, cara kerja, dan
                          pendekatan yang paling efektif buatmu.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          Komunikasi yang Lebih Efektif: Ketika kamu tahu
                          persona orang lain, kamu bisa menyampaikan ide atau
                          pendapat dengan cara yang lebih mereka pahami dan
                          hargai. Ini juga membantu menghindari kesalahpahaman.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          Hubungan Sosial yang Lebih Sehat: Bisa lebih toleran
                          dan empati terhadap perbedaan karakter atau cara
                          berpikir orang lain. Kamu juga bisa menyesuaikan
                          pendekatan dalam hubungan (teman, pasangan, rekan
                          kerja) agar lebih harmonis.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          Meningkatkan Kepemimpinan dan Kolaborasi : Seorang
                          pemimpin yang mengenal berbagai jenis persona akan
                          lebih mudah memotivasi dan membangun tim yang solid.
                          Dalam kerja tim, mengenali persona masing-masing
                          membantu membagi peran dengan lebih adil dan efektif.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          Pengambilan Keputusan yang Lebih Bijak: Kamu bisa
                          mempertimbangkan apakah keputusan tertentu sesuai
                          dengan kepribadian dan nilai-nilaimu. Juga bisa
                          memahami bagaimana orang lain mungkin bereaksi
                          terhadap keputusan yang diambil.
                        </Text>
                      </li>
                    </ol>
                    <Text fontWeight="bold">
                      Kalau kamu tertarik, kita juga bisa bahas tipe-tipe
                      persona atau kepribadian lebih dalam, Mau coba pilihlah?
                    </Text>
                  </Flex>
                </Flex>
              </Flex>
            </Flex>
            <Flex direction="column" flex={7} gap={4}>
              <Flex
                gap={4}
                direction="column"
                position="sticky"
                top="60px"
                zIndex={99}
                backgroundColor="#fff"
                width={{ base: "100%" }}
                paddingBottom="10px"
              >
                <Flex
                  bgColor="#1a7b28ff"
                  borderTopRadius={10}
                  direction="row"
                  justifyContent="space-between"
                  width="100%"
                  cursor="pointer"
                  onClick={() => setShowPilihan(!showPilihan)}
                  py={2}
                  px={3}
                >
                  <Text color="white" fontWeight="bold">
                    Pilihan Persona
                  </Text>
                  <Flex direction="row" gap={2} alignItems="center">
                    <Text color="white" fontWeight="bold">
                      {personaMode === 0
                        ? "My Persona"
                        : personaMode === 1
                          ? "Friend Persona"
                          : "Colleague Persona"}
                    </Text>
                    {showPilihan ? (
                      <ChevronUpIcon color={"#fff"} />
                    ) : (
                      <ChevronDownIcon color={"#fff"} />
                    )}
                  </Flex>
                </Flex>
                {showPilihan && (
                  <Flex flexDirection="column" gap={2}>
                    <Flex flexDirection="row">
                      <Button
                        py={2}
                        px={8}
                        color={personaMode === 0 ? "white" : "#000"}
                        borderRadius={10}
                        borderColor="#3F562A"
                        borderWidth={1}
                        fontWeight="bold"
                        width={{ sm: "100%", md: "40%" }}
                        textAlign="start"
                        justifyContent="start"
                        bgColor={personaMode === 0 ? "#3F562A" : "#CADFB8"}
                        onClick={() => {
                          onChangeMode(0);
                          setUser(localUser);
                          setShowPilihan(false);
                        }}
                      >
                        My Persona
                      </Button>
                    </Flex>
                    <Flex flexDirection={{ sm: "column", md: "row" }} gap={3}>
                      <Button
                        py={2}
                        px={8}
                        color={personaMode === 1 ? "white" : "#000"}
                        borderColor="#3F562A"
                        borderWidth={1}
                        borderRadius={10}
                        fontWeight="bold"
                        width={{ sm: "100%", md: "40%" }}
                        textAlign="start"
                        justifyContent="start"
                        bgColor={personaMode === 1 ? "#3F562A" : "#CADFB8"}
                        onClick={() => onChangeMode(1)}
                      >
                        Friends Persona
                      </Button>
                      {/* {personaMode === 1 && ( */}
                      <Flex
                        flexDirection="row"
                        gap={2}
                        width={{ sm: "100%", md: "50%" }}
                      >
                        <Flex flexDirection="column" width="100%">
                          <Input
                            value={nameUser}
                            border="1px solid blue"
                            px={3}
                            py={2}
                            borderRadius={5}
                            width="100%"
                            fontSize={{ sm: "xs", md: "sm" }}
                            placeholder="Search by name (min 3 huruf)"
                            onChange={onChangeSearch}
                            onFocus={() => onChangeMode(1)}
                            onBlur={() => console.log("ini blur")}
                          />
                          {searchData.length > 0 && personaMode === 1 && (
                            <Flex
                              flexDirection="column"
                              flex={1}
                              gap={2}
                              position="relative"
                            >
                              <Flex
                                flexDirection="column"
                                width="100%"
                                flex={1}
                                gap={2}
                                position="absolute"
                                backgroundColor="#fff"
                                borderWidth={1}
                                px={5}
                                py={2}
                                zIndex={1}
                              >
                                {searchData.map((data, index) => (
                                  <Button
                                    key={index}
                                    justifyContent="start"
                                    color={"black"}
                                    fontSize={{ sm: "xs", md: "sm" }}
                                    onClick={() => onSelectUser(data)}
                                    py="5px"
                                  >
                                    {data.name}
                                  </Button>
                                ))}
                              </Flex>
                            </Flex>
                          )}
                        </Flex>
                      </Flex>
                      {/* )} */}
                    </Flex>
                    <Flex flexDirection={{ sm: "column", md: "row" }} gap={3}>
                      <Button
                        py={2}
                        px={8}
                        color={personaMode === 2 ? "white" : "#000"}
                        borderRadius={10}
                        borderColor="#3F562A"
                        borderWidth={1}
                        fontWeight="bold"
                        width={{ sm: "100%", md: "40%" }}
                        textAlign="start"
                        justifyContent="start"
                        bgColor={personaMode === 2 ? "#3F562A" : "#CADFB8"}
                        onClick={() => onChangeMode(2)}
                      >
                        Colleague Persona
                      </Button>
                      {/* {personaMode === 2 && ( */}
                      <Flex
                        flexDirection="row"
                        gap={2}
                        width={{ sm: "100%", md: "50%" }}
                      >
                        <Flex flexDirection="column" width="100%">
                          <Input
                            value={nameColleague}
                            border="1px solid blue"
                            px={3}
                            py={2}
                            borderRadius={5}
                            width="100%"
                            fontSize={{ sm: "xs", md: "sm" }}
                            placeholder="Search by name (min 3 huruf)"
                            onChange={onChangeSearch}
                            onFocus={() => onChangeMode(2)}
                          />
                          {searchData.length > 0 && personaMode === 2 && (
                            <Flex
                              flexDirection="column"
                              flex={1}
                              gap={2}
                              position="relative"
                            >
                              <Flex
                                flexDirection="column"
                                width="100%"
                                flex={1}
                                gap={2}
                                position="absolute"
                                backgroundColor="#fff"
                                borderWidth={1}
                                px={5}
                                py={2}
                                zIndex={1}
                              >
                                {searchData.map((data, index) => (
                                  <Button
                                    key={index}
                                    justifyContent="start"
                                    color={"black"}
                                    fontSize={{ sm: "xs", md: "sm" }}
                                    onClick={() => onSelectUser(data)}
                                    py="5px"
                                  >
                                    {data.name}
                                  </Button>
                                ))}
                              </Flex>
                            </Flex>
                          )}
                        </Flex>
                        <Button
                          borderWidth={1}
                          bgColor="#FAEDCA"
                          borderColor="#1877f2"
                          color="#fff"
                          fontSize="sm"
                          fontWeight="bold"
                          borderRadius="5px"
                          px="10px"
                          py="5px"
                          onClick={() =>
                            window.location.assign(
                              "/dashboard/friend-list/add-colleague?from=matching",
                            )
                          }
                        >
                          <Image
                            src={Add}
                            w={{ base: "25px", "3xl": "25px" }}
                            h={{ base: "25px", "3xl": "25px" }}
                            borderRadius="20px"
                          />
                        </Button>
                      </Flex>
                      {/* )} */}
                    </Flex>
                  </Flex>
                )}
                <Flex direction="row" gap={5} id="sticky" flexWrap="wrap">
                  <Button
                    bgColor={activeCard === 0 ? "blue.500" : "gray.100"}
                    color={activeCard === 0 ? "white" : "black"}
                    borderColor="blue.500"
                    borderWidth={1}
                    fontSize={{ sm: "xs", md: "sm" }}
                    fontWeight="bold"
                    borderRadius="5px"
                    onClick={() => onClickCard(0)}
                    px={{ sm: "10px", md: "30px" }}
                    py="5px"
                  >
                    Profile
                  </Button>
                  <Button
                    bgColor={activeCard === 1 ? "blue.500" : "gray.100"}
                    color={activeCard === 1 ? "white" : "black"}
                    borderColor="blue.500"
                    borderWidth={1}
                    fontSize={{ sm: "xs", md: "sm" }}
                    fontWeight="bold"
                    borderRadius="5px"
                    onClick={() => onClickCard(1)}
                    px={{ sm: "10px", md: "30px" }}
                    py="5px"
                  >
                    Annually
                  </Button>
                  <Button
                    bgColor={activeCard === 2 ? "blue.500" : "gray.100"}
                    color={activeCard === 2 ? "white" : "black"}
                    borderColor="blue.500"
                    borderWidth={1}
                    fontSize={{ sm: "xs", md: "sm" }}
                    fontWeight="bold"
                    borderRadius="5px"
                    onClick={() => onClickCard(2)}
                    px={{ sm: "10px", md: "30px" }}
                    py="5px"
                  >
                    Daily Vibe
                  </Button>
                </Flex>
              </Flex>
              <Flex direction="column" gap={4}>
                {user?.name && (
                  <Flex
                    m="10px 10px"
                    w="max-content"
                    direction="row"
                    alignItems="center"
                    gap={5}
                  >
                    <Flex direction="column">
                      <Avatar
                        mx="auto"
                        src={user?.photo}
                        h={{ sm: "50px", lg: "80px" }}
                        w={{ sm: "50px", lg: "80px" }}
                        border="2px solid"
                        borderColor={"white"}
                      />
                    </Flex>
                    <Flex align="start" direction="column">
                      <Text
                        color={"#000"}
                        fontWeight="bold"
                        fontSize={{ sm: "xs", md: "sm", lg: "md" }}
                      >
                        {user?.name?.slice(0, 10)}
                      </Text>
                      <Text color={"#000"} fontSize={{ sm: "xs", lg: "sm" }}>
                        {user?.occupation}
                      </Text>
                    </Flex>
                  </Flex>
                )}
                {cards.length > 0 && (
                  <Flex direction="column" gap={3} width={{ md: "100%" }}>
                    {cards.map((card, index) => (
                      <Flex direction="column" key={index} gap={1}>
                        <Text
                          fontWeight="bold"
                          textTransform="uppercase"
                          color="#B82132"
                          fontSize={{ sm: "sm", md: "md" }}
                        >
                          {card?.title}
                        </Text>
                        {card?.title === "Daily Analytic" && (
                          <>
                            <Text>{moment().format("D MMMM YYYY")}</Text>
                            <Flex
                              direction="column"
                              gap={1}
                              alignItems="center"
                              my={4}
                            >
                              <Text
                                textAlign="center"
                                fontSize="lg"
                                fontWeight="bold"
                              >
                                {stats}%
                              </Text>
                              <LinearProgress
                                sx={{
                                  height: 20,
                                  borderRadius: 3,
                                  width: "100%",
                                }}
                                color={"info"}
                                variant="determinate"
                                value={stats}
                              />
                            </Flex>
                          </>
                        )}
                        <Flex
                          position="relative"
                          flexDirection="column"
                          borderWidth={0.5}
                          borderRadius={15}
                          padding={2}
                          borderColor="lightgrey"
                        >
                          {index > 0 && !isUnlocked && (
                            <Flex
                              position="absolute"
                              zIndex={1}
                              bgColor="#efefefd9"
                              left={0}
                              width="100%"
                              height="100%"
                              top={0}
                              borderRadius={15}
                              alignItems="center"
                              justifyContent="center"
                              flexDirection="column"
                            >
                              <MdLock size={40} />
                              <Text>Unlocked</Text>
                            </Flex>
                          )}
                          {isUnlocked ? (
                            <>
                              {card.texts.map((text) => (
                                <Flex direction="column" gap={5}>
                                  {text.map((item, i) => (
                                    <Flex direction="column" gap={1}>
                                      <Text
                                        fontWeight="bold"
                                        fontSize={{ sm: "xs", md: "md" }}
                                      >
                                        {item.title != "null" && item?.title}
                                      </Text>
                                      <Text
                                        textOverflow="ellipsis"
                                        whiteSpace="pre-line"
                                        fontSize={{ sm: "xs", md: "md" }}
                                      >
                                        {item?.text}
                                      </Text>
                                    </Flex>
                                  ))}
                                </Flex>
                              ))}
                            </>
                          ) : (
                            <Flex direction="column" gap={1}>
                              <Text
                                fontWeight="bold"
                                fontSize={{ sm: "xs", md: "md" }}
                              >
                                {card?.texts[0][0]?.title != "null" &&
                                  card?.texts[0][0]?.title}
                              </Text>
                              <Text
                                textOverflow="ellipsis"
                                whiteSpace="pre-line"
                                fontSize={{ sm: "xs", md: "md" }}
                              >
                                {card?.texts[0][0]?.text}
                              </Text>
                              <Text
                                color="#3D3BF3"
                                fontSize={{ sm: "xs", md: "sm" }}
                                fontStyle="italic"
                                textAlign="end"
                                mt={0}
                                cursor="pointer"
                                onClick={() =>
                                  onClickOpen(card.texts[0][0].text)
                                }
                              >
                                {isUnlocked && card.texts[0][0].text !== open
                                  ? "Read more"
                                  : isUnlocked && card.texts[0][0].text === open
                                    ? "Show less"
                                    : "Baca lengkap"}
                              </Text>
                            </Flex>
                          )}
                        </Flex>
                      </Flex>
                    ))}
                  </Flex>
                )}
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </div>
      <Footer />
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={showDialog}
        disableScrollLock
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Deep Dive
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Flex
            flexDirection="row"
            wrap="wrap"
            maxWidth="100%"
            gap={8}
            alignItems="center"
            justifyContent="center"
          >
            <Text>Apakah anda ingin menyimpan persona ini?</Text>
          </Flex>
        </DialogContent>
        <DialogActions>
          <Button
            borderWidth={1}
            // borderColor="#1877f2"
            bg={"green"}
            color="white"
            fontSize="sm"
            fontWeight="bold"
            borderRadius="5px"
            px="10px"
            py="5px"
            // onClick={() => onSaveMatching()}
            // disabled={pagination.page === pagination.max}
          >
            Save
          </Button>
        </DialogActions>
      </BootstrapDialog>
      <BootstrapDialog
        fullWidth
        onClose={handleClosePricing}
        open={isShowPricing}
        maxWidth="xs"
        disableScrollLock
      >
        <DialogTitle
          sx={{ m: 0, p: 3, backgroundColor: "#DDF4E7" }}
          id="customized-dialog-title"
        ></DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClosePricing}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon width={3} />
        </IconButton>
        <DialogContent sx={{ alignSelf: "center" }}>
          <Flex
            flexDirection="column"
            wrap="wrap"
            maxWidth="100%"
            gap={1}
            alignItems="center"
            justifyContent="center"
          >
            <PricingPersona
              user={user}
              type={
                nameColleague !== ""
                  ? "colleague"
                  : nameUser !== ""
                    ? "friend"
                    : ""
              }
              product={service?.persona}
            />
          </Flex>
        </DialogContent>
      </BootstrapDialog>
    </div>
  );
};

export default Persona;
